import React from "react";
import { inject, observer } from "mobx-react";

const CampaignInfo = (props) => {
  const { progress } = props.overlayStore;

  const queryString = window.location.search;

  const findParam = (param) => {
    if (param) {
      const slug = window.location.pathname.split("/")[4].split("&");

      const paramValue = slug.filter((str) => {
        return str.includes(param);
      });

      if (paramValue.length > 0) {
        return paramValue[0].split("=")[1];
      }

      return null;
    }

    return null;
  };

  const urlParams = new URLSearchParams(queryString);
  const thermColor = urlParams.get("thermColor")
    ? urlParams.get("thermColor")
    : findParam("thermColor");

  return (
    <div className="container">
      <div className="therm-container">
        <div
          className={`therm-inner ${thermColor}`}
          style={{
            width: `
                ${progress}%
              `,
          }}
        ></div>
      </div>
    </div>
  );
};

export default inject("overlayStore")(observer(CampaignInfo));
